
    import React, { useEffect } from 'react';
    import { useLocation } from 'react-router-dom';

    const ScrollToTop = () => {
      const { pathname } = useLocation();

      useEffect(() => {
        try {
          window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'auto' 
          });
        } catch (error) {
          window.scrollTo(0, 0);
        }
      }, [pathname]);

      return null;
    };

    export default ScrollToTop;
  